import React, { useEffect, useState } from 'react';
import { getSmsDurum, smsGonder, smsOnizleme } from '../services/api';

// SMS gönderme penceresi — TÜM ekranlardan kullanılmak üzere ortak bileşen
// (kullanıcı talebi: 2026-09-03). İlk kullanan ekran Call Center.
//
// Kullanımı:  <SmsGonder numara="05XXXXXXXXX" adSoy="..." kaynak="Son Telefon" kapat={...} gonderildi={...} />
//
// Sunucu tarafı yetkisi TEKN.YETK_CALL_2'dir; yetkisi olmayan kullanıcıda "durum" isteği 403
// döner ve pencere bunu açıkça yazar.

// kaynak: numaranin hangi alandan geldigi ("Son Telefon" / "Telefon") — operatore
// hangi numaraya gonderdigi acikca gosterilsin diye baslikta yazilir.
export default function SmsGonder({ numara, adSoy, kaynak, kapat, gonderildi }) {
  const [mesaj, setMesaj] = useState('');
  const [durum, setDurum] = useState(null);
  const [uzunluk, setUzunluk] = useState({ uzunluk: 0, parca: 0 });
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [hata, setHata] = useState('');
  const [yetkiYok, setYetkiYok] = useState(false);
  const [uyari, setUyari] = useState('');

  // Doldurulmamis yer tutucular. Sunucu onizlemesi de bunlari doner ama burada anlik
  // hesaplanir ki kullanici yazarken dugme gecikmeden kapansin.
  const yerTutucular = [...new Set(mesaj.match(/#[A-ZÇĞİÖŞÜ][A-ZÇĞİÖŞÜ0-9_]*/g) || [])];

  useEffect(() => {
    getSmsDurum()
      .then(res => setDurum(res.data))
      .catch(err => {
        if (err.response?.status === 403) setYetkiYok(true);
        else setHata(err.response?.data?.hata || 'SMS ayarları okunamadı.');
      });
  }, []);

  // Uzunluk/parça hesabı sunucuda yapılır — Türkçe sadeleştirmesi de orada olduğu için
  // ekranda gösterilen sayı gerçekten gönderilecek metnin sayısıdır.
  useEffect(() => {
    if (!mesaj.trim()) { setUzunluk({ uzunluk: 0, parca: 0 }); return undefined; }
    const zaman = setTimeout(() => {
      smsOnizleme(mesaj).then(res => setUzunluk(res.data)).catch(() => {});
    }, 300);
    return () => clearTimeout(zaman);
  }, [mesaj]);

  const gonder = async (e) => {
    e.preventDefault();
    setHata('');
    if (!mesaj.trim()) { setHata('Lütfen yollanacak mesaj metnini yazınız.'); return; }
    if (yerTutucular.length) { setHata(`Mesajda doldurulmamış yer tutucu var: ${yerTutucular.join(', ')}`); return; }

    setGonderiliyor(true);
    try {
      const res = await smsGonder(numara, mesaj);
      // Sağlayıcının mesaj kimliği de yazılır: teslim edilmeyen mesajlarda operatörün
      // elinde takip için bir referans olsun (2026-09-03).
      const ref = res.data.saglayiciYaniti ? ` — sağlayıcı yanıtı: ${res.data.saglayiciYaniti}` : '';
      gonderildi(`${adSoy || numara} · ${res.data.numara} numarasına SMS gönderildi (${res.data.uzunluk} karakter)${ref}`);
    } catch (err) {
      setHata(err.response?.data?.hata || 'SMS gönderilemedi.');
    } finally {
      setGonderiliyor(false);
    }
  };

  return (
    <div className="cc-modal-zemin" onClick={e => { if (e.target === e.currentTarget && !gonderiliyor) kapat(); }}>
      <div className="cc-modal" style={{ maxWidth: 520 }}>
        <div className="cc-modal-baslik">
          <div>
            <strong>💬 SMS Gönder</strong>
            <small>{adSoy ? `${adSoy} · ` : ''}{kaynak ? `${kaynak}: ` : ''}{numara}{durum?.gonderen ? ` · gönderen: ${durum.gonderen}` : ''}{durum?.kurum ? ` (${durum.kurum})` : ''}</small>
          </div>
          <button onClick={kapat} disabled={gonderiliyor}
                  style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.85)', fontSize: 22, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>

        <form onSubmit={gonder} style={{ padding: 20 }}>
          {yetkiYok && <div className="hata-kutu">SMS gönderme yetkiniz yok.</div>}
          {durum && !durum.hazir && <div className="hata-kutu">{durum.sebep}</div>}

          {durum?.sablonlar?.length > 0 && (
            <div style={{ marginBottom: 14 }}>
              <label className="cc-etiket">Hazır Metinler</label>
              {/* Tek sütun: iki sütunda cümle kalıbı okunmuyordu (kullanıcı talebi). */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                {durum.sablonlar.map((s, i) => (
                  <button key={i} type="button" className="btn btn-secondary"
                          style={{
                            padding: '6px 9px', fontSize: 11.5, textAlign: 'left',
                            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                          }}
                          title={s} onClick={() => setMesaj(s)}>
                    {i + 1}. {s}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* #KR / #KT / #KONUM sunucuda şubenin kurum bilgileriyle dolduruldu.
              #ST1 randevu tarih/saatidir; çağrı kaydında böyle bir bilgi olmadığı için
              boş kalır. Doldurulmamış yer tutucu varsa GÖNDERİM ENGELLENİR — sunucu da
              aynı kontrolü yapar (kullanıcı talebi: 2026-09-03). */}
          {yerTutucular.length > 0 && (
            <div className="hata-kutu">
              Mesajda doldurulmamış yer tutucu var: <strong>{yerTutucular.join(', ')}</strong>.
              {yerTutucular.includes('#ST1') && ' #ST1 randevu tarih/saatidir.'}
              {' '}Doğru bilgiyi yazın veya bu kısmı silin — SMS bu hâliyle gönderilemez.
            </div>
          )}

          <div style={{ marginBottom: 6 }}>
            <label className="cc-etiket">SMS Mesaj Metni</label>
            {/* < > & yazılamaz: XML'de anlam taşıdıkları için sağlayıcıya hiç gönderilmiyorlar.
                Bir SMS metninde zaten işe yaramazlar. Kesme işareti ve tırnak SERBEST —
                Türkçede gerekli ve XML element içeriğinde sorunsuz. */}
            <textarea value={mesaj}
                      onChange={e => {
                        const temiz = e.target.value.replace(/[<>&]/g, '');
                        if (temiz !== e.target.value) setUyari('< > & karakterleri SMS metninde kullanılamaz.');
                        setMesaj(temiz);
                      }}
                      rows={5} maxLength={900} style={{ width: '100%', resize: 'vertical' }} />
          </div>

          <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 14 }}>
            Mesaj uzunluğu: <strong>{uzunluk.uzunluk}</strong> karakter
            {uzunluk.parca > 0 && <> · <strong>{uzunluk.parca}</strong> SMS olarak gidecek</>}
            {uzunluk.parca > 1 && <span style={{ color: '#A32D2D' }}> (her parça ayrı ücretlendirilir)</span>}
            <br />
            Türkçe karakterler gönderilmeden önce sadeleştirilir (ç→c, ş→s, ğ→g, ö→o, ü→u, ı→i).
          </div>

          {uyari && (
            <div className="hata-kutu" style={{ background: '#FAEEDA', color: '#633806' }}>{uyari}</div>
          )}

          {hata && <div className="hata-kutu">{hata}</div>}

          <div style={{ display: 'flex', gap: 8 }}>
            <button type="submit" className="btn btn-primary" style={{ flex: 1 }}
                    disabled={gonderiliyor || yetkiYok || yerTutucular.length > 0 || (durum && !durum.hazir)}>
              {gonderiliyor ? 'GÖNDERİLİYOR...' : '💬 SMS GÖNDER'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={kapat} disabled={gonderiliyor}>Kapat</button>
          </div>
        </form>
      </div>
    </div>
  );
}
